import type PersonalBookingPagePublishingSettings from './schema/PersonalBookingPagePublishingSettings';
import { createStore } from 'satcheljs';
import '../mutators/initializeSettingsMutator';

let initialStore: PersonalBookingPagePublishingSettings = {
    publishingSettings: null,
    isAnonymousSharingEnabled: false,
    owaCalendarBookingButtonEnabled: false,
};

export default createStore<PersonalBookingPagePublishingSettings>(
    'personalBookingPagePublishingSettings',
    initialStore
);
